import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import BadgeVerifyApp from './BadgeVerifyApp';
import './styles/takeover.css';

// The seller ID-badge verification page is a ROUTE inside this app (design §15):
// a magic link `/badge/<token>` renders the guided badge flow instead of the
// 21-step takeover wizard. Amplify must SPA-rewrite `/badge/*` → index.html.
const isBadge = typeof window !== 'undefined' && window.location.pathname.startsWith('/badge/');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(isBadge ? <BadgeVerifyApp /> : <App />);
